/**
 * Stops a click inside a modal's content from reaching the overlay's own
 * backdrop-click handler (which closes the modal). Deliberately does NOT
 * call preventDefault: a label wrapping a hidden file input opens the
 * native file picker via the browser's default click behavior on the
 * label, not via any of our own code — cancelling the default action here
 * silently breaks that (XPEN-3076), and the same applies to any other
 * interactive descendant (a native date input, a checkbox, a link).
 * stopPropagation is sufficient to keep the overlay open; nothing else
 * needs to be cancelled.
 *
 * @param {Event} e - The click event bubbling up from inside the modal.
 */
export const stopClickReachingOverlay = (e) => {
  e.stopPropagation();
};
